import StudySnapshot from "components/StudySnapshot";
import { Text } from "design_system";
import { Paper } from "helpers/api";
import useLabels from "hooks/useLabels";

type StudySnapshotTabProps = {
  paper: Paper;
};

function StudySnapshotTab({ paper }: StudySnapshotTabProps) {
  const [labels] = useLabels("features.paper-sidebar-drawer");

  return (
    <div className="overflow-y-auto p-4 h-full">
      <div className="max-w-none">
        <Text weight="bold" size="lg" className="mb-3">
          {labels["study-snapshot-title"]}
        </Text>
        <Text className="mb-3">{paper.display_text}</Text>
        <StudySnapshot
          paperId={paper.paper_id}
          badges={paper.badges}
          fetchOnMount={false}
        />
      </div>
    </div>
  );
}

export default StudySnapshotTab;
